import { Store } from "utils";

class EventStore extends Store {
  getInitialState() {
    return {
      events: null,
      ready: false,
      loading: false,
      background: null,
    };
  }

  getEvents() {
    return this.getState().events;
  }

  getBackground() {
    return this.getState().background;
  }

  getDetails() {
    return this.getState().details;
  }

  onEventsLoading(state) {
    state.events = null;
    state.ready = true;
    state.loading = true;
  }

  onEventsChanged(state, data) {
    state.events = data.events;
    state.loading = false;
  }

  onEventDetailsChanged(state, data) {
    state.details = data.details;
  }

  isReady() {
    return this.getState().ready == true;
  }

  isLoading() {
    return this.getState().loading;
  }
}

const store = new EventStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/eventstore.js